<template>
  <div class="loader_skeleton" v-if="loading">
    <div class="content-body">
      <div class="card">
        <div class="card-datatable table-responsive pt-0 ">
          <table
            class="user-list-table table table-hover table-hover-animation"
          >
            <thead>
            <tr>
              <th class="table-head" v-for="(header, headerKey) in headerLength" :key="headerKey">{{ header.title }}</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="(tr, index) in 10" :key="index">
                <td v-for="(td, index) in headerLength.length" :key="index">
                  <span></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    headerLength: {
        type: Number,
        required: true
    }
  },
  watch: {},
  async data() {
    return {
    };
  },
};
</script>

<style>

</style>
